import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const Outer = styled.div`
    position: relative;
    min-height: calc(100vh - 32px);
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    z-index: 9999;

    ${breakpoints.large} {
        min-height: auto;
        margin-top: 0;
    }
`;

export const Inner = styled.div`
    position: relative;
    background-color: white;
    overflow: hidden;
    flex-grow: 1;
    background-color: ${colors.brandMid};
    height: 100%;
    padding-top: 72px;

    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    ${breakpoints.large} {
        padding-top: 0;
        border-radius: 24px;
    }
`;

export const InnerInner = styled.div`
    max-width: 600px;
    margin: 0 auto;
`;

export const Close = styled.div`
    display: flex;
    justify-content: flex-end;
    background-color: ${colors.brandMid};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    ${breakpoints.large} {
        background-color: transparent;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
    }
`;

export const CloseButton = styled.div`
    padding: 16px;
    border: 0;
    transition: 200ms ease all;
    background-color: transparent;
    cursor: pointer;

    ${breakpoints.large} {
        transform: translateY(-100%);
        margin-right: 30px;
    }
`;

export const Header = styled.div`
    padding: 0 32px 32px 32px;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    margin: 0 auto;

    > * {
        width: 100%;
        margin: 0;
    }

    ${breakpoints.large} {
        padding: 200px 0;
        align-items: center;
    }
`;

export const Title = styled.h3`
    font-size: 32px;
    color: white;

    ${breakpoints.medium} {
        font-size: 56px;
    }
`;

export const SubTitle = styled.div`
    font-size: 18px;
    margin-top: 16px;

    p {
        color: white;
    }

    strong {
        font-weight: 800;
        opacity: 1;
    }
`;

export const NoMatchError = styled.p`
    color: ${colors.brandLight};
    margin: 0;
    margin-top: 12px;
    display: flex;
    gap: 12px;
    text-align: left;
    vertical-align: middle;
    font-size: 1em;
    line-height: 1.5em;
`;

export const CheckboxLabel = styled.label`
    width: 100%;

    /* display: inline-flex; */
    /* align-items: center; */
    color: white;
    margin: 0;
    margin-top: 24px;
    font-size: 14px;

    input {
        margin-right: 8px;
    }
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    gap: 16px;

    > *:first-child {
        flex-grow: 1;
    }
    
    ${breakpoints.medium} {
        .popup-button { width: 215.44px; }
        flex-direction: row;
        gap: 16px;
    }
`;
